import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL || 'api'
// const LAYOUT_CONFIG_KEY = process.env.REACT_APP_BASE_LAYOUT_CONFIG_KEY || 'LayoutConfig'

let response: UserModel = {
  id: 0,
  username: '',
  password: '',
  email: '',
}

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/get-user`
export const LOGIN_URL = `${API_URL}/login`
export const RESET_PASSWORD_URL = `${API_URL}/reset_password`
// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password/:id/:signature`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const REQUEST_RESEND_EMAIL_VERIFY = `${API_URL}/resend_email_verify`

export const VERIRY_EMAIL_URL = `${API_URL}/verify_email/:id/:signature`
export const CHANGE_PASSWORD_URL = `${API_URL}/v1/change_password`

//BUSCA TOKEN NO LOCALSTORAGE
let token = localStorage.getItem('auth_storage')
if (token) token = token.replace(/['"]+/g, '')
let config = {
  headers: {
    Authorization: 'Bearer ' + token,
  },
}

export async function login(email: string, password: string) {
  const {data} = await axios.post(LOGIN_URL, {email, password, device_name: 'web'})
  setTimeout(() => {}, 2000)

  //variável do usuario do retorno da requisição
  let usuario = data.data.User

  //variável do token do retorno da requisição
  let authorization = data.data.Token

  //variável do token do retorno da requisição
  let roles = usuario.roles

  //variável do token do retorno da requisição
  let permissions = usuario.permissions

  //variável do usuario
  const user: UserModel = {
    id: usuario.id,
    username: usuario.username,
    password: password,
    email: usuario.email,
    pic: usuario.pic,
    lastname: usuario.lastname,
    firstname: usuario.firstname,
    uuid: usuario.uuid,
    picture: usuario.picture,
    active: usuario.active,
  }

  //variável de a
  const auth: AuthModel = {
    api_token: authorization,
    refreshToken: authorization,
  }
  //variável global de resposta
  response = user
  response.password = undefined
  localStorage.setItem('user_storage', JSON.stringify({response}))
  localStorage.setItem('auth_storage', JSON.stringify(authorization))
  localStorage.setItem('permissions_storage', JSON.stringify(permissions))
  localStorage.setItem('roles_storage', JSON.stringify(roles[0]))
  return {data: auth}
}

// Server should return AuthModel
export function resetPassword(token: string, password: string, confirm_password: string) {
  return axios.patch<AuthModel>(RESET_PASSWORD_URL, {
    token,
    password,
    confirm_password,
  })
}

export function changePassword(
  current_password: string,
  password: string,
  confirm_password: string
) {
  return axios.patch<AuthModel>(
    CHANGE_PASSWORD_URL,
    {
      current_password,
      password,
      confirm_password,
    },
    config
  )
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {email})
}
export function resendEmail(email: string) {
  return axios.post<{result: boolean}>(REQUEST_RESEND_EMAIL_VERIFY, {email})
}
export function veriryPassword(url: any) {
  return axios.post<{result: boolean}>(url)
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  //return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
  //return axios.post<UserModel>(LOGIN_URL, {email:resp.email, password:resp.password});
  //localStorage.setItem('persist:v100-demo1-auth',JSON.stringify({user:response}));
  const user = localStorage.getItem('user_storage')

  if (user) {
    try {
      let {response} = JSON.parse(user)
      return {data: response}
    } catch (er) {
      console.error(er)
      return {data: er}
    }
  } else {
    return {data: ''}
  }
}
